import axios from '@/libraries/axios/axiosConfig';

export default async function postTrailerAssessmentHasPhotos(
    assessmentId: string | number,
    hasPhotos: boolean,
    source = 'Trailer Solutions Driver Assessment'
): Promise<{ isSuccessful: boolean }> {
    const response = await axios({
        method: 'post',
        url: `${process.env.VUE_APP_EXT_API_URL}api/trailers/trailerAssessmentHasPhotos`,
        data: {
            assessmentId,
            hasPhotos,
            source,
        },
    });

    return response.data;
}
